import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";


function CompanyChange({ show, onHide, changeHandler, log, loading, selected }) {

    const stateCompany = useSelector((state) => state.companyList);//Информация о компаниях
    //const stateSetting = useSelector((state) => state.setting);//Настройки приложения 

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body className="">
                    <div className="modal_title text-center mb-20"> Выберите компанию</div>
                    <div className="mb-15">
                        {stateCompany.list.filter(a => a.ID_Status === 1).map((item) => (
                            item.ID === selected ? (
                                <div key={item.ID} className="list_item mt-15" style={{ cursor: "default", backgroundColor: "#e3e3e3" }}> <FontAwesomeIcon icon={faCheck} className="mr-15 text-success" />{item.Name}</div>

                            ) : (
                                <div key={item.ID} className="list_item mt-15" onClick={() => changeHandler(item.ID)} > <FontAwesomeIcon icon={faBuilding} className="mr-15" />{item.Name}</div>
                            )
                        ))}
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    {loading === true && <div className="loader_01"></div>}
                </Modal.Body>
            </Modal>
        </>
    );
}
export default CompanyChange;
